import React from 'react';
import { css as emotionCss } from 'emotion';
import { HeaderActionArea } from '../Layout.styled';
import { headerCollapseAction } from '../../styles/legacy';
import { getStyleNames } from '@citrus/runtime';
import { capitalize } from '@pcty/utils';
var ActionArea = function (_a) {
    var _b;
    var renderActionArea = _a.renderActionArea, actionAreaBreakpoint = _a.actionAreaBreakpoint;
    var styleNames = (_b = {},
        _b['headerCollapse' + capitalize(actionAreaBreakpoint || '')] = true,
        _b);
    return (React.createElement(HeaderActionArea, { className: emotionCss(headerCollapseAction[actionAreaBreakpoint || '']), styleNames: getStyleNames(styleNames) }, renderActionArea()));
};
export default ActionArea;
